import { mapActions, mapState } from 'pinia'

import Header from '@/components/Header.vue'
import Sidebar from '@/components/Sidebar.vue'
import { app, pages } from '@/config'
import { useCommonStore } from '@/stores/common.js'
import { useConfigStore } from '@/stores/config.js'
import { useMemberStore } from '@/stores/member.js'
import ErrorState from '@/utils/components/ErrorState.vue'

const SIDEBAR_PAGE_NAME_LIST = [
  pages.banner.name,
  pages.commission.name,
  pages.generateLink.name,
  pages.performance.name,
  pages.contract.name,
  pages.bonusCommission.name,
  pages.profile.name,
  pages.changePassword.name,
  pages.bankInformation.name
]

export default {
  components: {
    Header,
    Sidebar,
    ErrorState
  },
  computed: {
    ...mapState(useMemberStore, ['isAuthLoading']),
    ...mapState(useCommonStore, ['errorCode']),
    isHeaderShown () {
      const currentPath = this.$route.path

      const isHiddenPath = app.hiddenHeaderPaths.includes(currentPath)

      const isInHiddenRegex = app.hiddenHeaderPathRegex
        ? app.hiddenHeaderPathRegex.some(regex => !currentPath.search(regex))
        : false

      return !(isHiddenPath || isInHiddenRegex)
    },
    isSidebarShown () {
      return SIDEBAR_PAGE_NAME_LIST.includes(this.$route.name) && !this.errorCode
    }
  },
  methods: {
    ...mapActions(useMemberStore, ['getProfile']),
    ...mapActions(useConfigStore, ['getBusinessAffiliateConfig']),
    init () {
      this.getProfile()
      this.getBusinessAffiliateConfig()
    }
  },
  created () {
    this.init()
  }
}
